import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import { showPopinProductChangeStatus } from "../../actions";

const InternalOrderProductChangeStatus = ({
  order_product,
  meta,
  showPopinChangeStatus,
  canShowChangeStatus,
}) => {
  let old_status = order_product.status;
  return (
    <span>
      {!canShowChangeStatus && meta.order_product_status[old_status]}
      {canShowChangeStatus && (
        <Button
          size="xs"
          style={{ marginLeft: "3px" }}
          onClick={() => showPopinChangeStatus(order_product)}
        >
          <i className="fa-solid fa-pen-to-square"></i>{" "}
          {meta.order_product_status[old_status]}
        </Button>
      )}
    </span>
  );
};

InternalOrderProductChangeStatus.propTypes = {
  meta: PropTypes.object,
  order_product: PropTypes.object,
  showPopinChangeStatus: PropTypes.func,
  canShowChangeStatus: PropTypes.bool,
};

export default connect(
  (state, ownProp) => {
    return {
      meta: state.support.meta,
      canShowChangeStatus:
        state.user.is_without_prep_check &&
        state.support.meta.order_prepare_status.includes(ownProp.order.status),
    };
  },
  (dispatch) => {
    return {
      showPopinChangeStatus: (op) => {
        dispatch(showPopinProductChangeStatus(op));
      },
    };
  }
)(InternalOrderProductChangeStatus);
